<template>
    <h1 class="text-left text-[24px] pb-[6px]">{{ title }}</h1>
    <p class="text-[14px] pb-[34px]">{{ text }}</p>
</template>
<script>
export default {
    props: {
        title: String,
        text: String
    }
}
</script>